import { TFetchConverter } from 'data/types/Converter.types';
import {
  TAllowedAnimalActionsDB,
  TAllowedAnimalActionsUI,
} from 'data/types/AnimalActions.types';

// A flag the running backend has not shipped yet reads as "not allowed" rather than undefined, so
// a view can branch on it without guarding every one.
export const allowedAnimalActionsConverter: TFetchConverter<
  TAllowedAnimalActionsUI,
  TAllowedAnimalActionsDB
> = {
  fromDb: data => ({
    canApprove: !!data.canApprove,
    canReject: !!data.canReject,
    canConditionallyApprove: !!data.canConditionallyApprove,
    canApproveConditionallyApprove: !!data.canApproveConditionallyApprove,
    canRetract: !!data.canRetract,
    canReapply: !!data.canReapply,
    canAbandon: !!data.canAbandon,
    canReset: !!data.canReset,
    canMoveIn: !!data.canMoveIn,
    canRevokeMoveIn: !!data.canRevokeMoveIn,
    canMoveOut: !!data.canMoveOut,
    canRevokeMoveOut: !!data.canRevokeMoveOut,
  }),
};
